import Vue from 'vue';

Vue.component('promo-main-page-wrapper', {
    props: {
        initialRequestType: {
            type: String,
        },
        selectedTitle: {
            type: String,
        },
    },

    data() {
        return {
            requestType: null,
            requestIndex: 0,
            isSwitchButtonVisible: true,
        };
    },

    mounted() {
        this.handleSetDefaultRequestType();
        EventBus.$on('request-type-changed', (requestType) => {
            this.requestType = requestType;
        });
    },

    components: {
        'promo-main-page-listings': () =>
            import('../async-components/async-promo-main-page-listings'),
    },

    watch: {
        requestType(newValue) {
            this.campaignType =
                newValue === 'private'
                    ? 'privateCampaignArticles'
                    : 'businessCampaignArticles';
        },
    },

    methods: {
        handleSetDefaultRequestType() {
            const isRequestTypePrivate =
                this.initialRequestType.includes('private');
            this.requestType = isRequestTypePrivate ? 'private' : 'business';
            this.requestIndex = isRequestTypePrivate ? 0 : 1;
        },

        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },
    },
});
